import EnvironmentVariableRepositoryInterface from '../interface-adapters/EnvironmentVariableRepositoryInterface';
import EnvironmentVariableRepository from '../repositories/EnvironmentVariableRepository';

export default class EnvironmentVariableFactory {
    private static repo: EnvironmentVariableRepositoryInterface;

    public static makeRepo(): EnvironmentVariableRepositoryInterface {
        if (!this.repo) {
            this.repo = new EnvironmentVariableRepository();
        }

        return this.repo;
    }
}
